import base64 from 'base-64'
import Cookies from 'js-cookie'
import moment from 'moment'
export const TOKEN = 'token'
export const EXPIRES_ON = 'expires_on'
export const EXPIRES_DATE = 'expires_date'
export const USER_ID = 'user_id'
export const REDIRECT_URL = 'redirectUrl'
export const CLIENT_ID = 'clientId'
export const USER_FULLNAME = 'fullName'
export const USER_ROLE = 'userRole'
const expiresDay = 7

function getCookie(key) {
    const value = Cookies.get(key)
    let setValue = ''
    if (typeof value === 'string') {
        setValue = base64.decode(value)
    }
    return setValue
}

function setCookie(key, value, expires) {
    const valueToString = String(value)
    let setValue = ''
    if (typeof valueToString === 'string') {
        setValue = base64.encode(valueToString)
    }
    if (expires && typeof expires === "number" && expires > 0) {
        Cookies.set(key, setValue, { expires: expires })
    } else {
        Cookies.set(key, setValue)
    }

}

function removeCookie(key) {
    Cookies.remove(key)
}

export function authentication(dataAuth, isRemember) {
    if (dataAuth && dataAuth.result === true) {
        const { data } = dataAuth
        if (data && data.user) {
            clearToken()
            const { user, token, expiresOn, expiresDate } = data
            let setExpiresDay = expiresDay
            if (isRemember === false) {
                setExpiresDay = 0
            }
            if (token) setCookie(TOKEN, token, setExpiresDay)
            if (expiresOn) setCookie(EXPIRES_ON, expiresOn, setExpiresDay)
            if (expiresDate) setCookie(EXPIRES_DATE, expiresDate, setExpiresDay)
            if (user && user.id) setCookie(USER_ID, user.id, setExpiresDay)
            if (user && user.fullName) { setCookie(USER_FULLNAME, user.fullName, setExpiresDay) }
            if (user && user.role && user.role.code) { setCookie(USER_ROLE, user.role.name, setExpiresDay) }
        } else if (dataAuth.token) {
            setCookie(TOKEN, dataAuth.token,  dataAuth.expires_on)
            if (dataAuth.expires_on) setCookie(EXPIRES_ON, dataAuth.expires_on,  dataAuth.expires_on)
        }
    }
}

export function clearToken() {
    removeCookie(TOKEN)
    removeCookie(EXPIRES_ON)
    removeCookie(EXPIRES_DATE)
    removeCookie(USER_ID)
    removeCookie(USER_FULLNAME)
    removeCookie(REDIRECT_URL)
    removeCookie(CLIENT_ID)
    removeCookie(USER_ROLE)
}

export function getAllCookies() {
    return {
        [TOKEN]: getCookie(TOKEN),
        [EXPIRES_ON]: getCookie(EXPIRES_ON),
        [EXPIRES_DATE]: getCookie(EXPIRES_DATE),
        [USER_ID]: getCookie(USER_ID),
    }
}

export function getToken() {
    return getCookie(TOKEN)
}

export function getUserFullName() {
    return getCookie(USER_FULLNAME)
}

export function getUserRole() {
    return getCookie(USER_ROLE)
}

export function setBackendInfoCookie({ redirectUrl, clientId }) {
    setCookie(REDIRECT_URL, redirectUrl)
    setCookie(CLIENT_ID, clientId)
}

export function getBackendInfoCookie() {
    return { redirectUrl: getCookie(REDIRECT_URL), clientId: getCookie(CLIENT_ID) }
}

export function setDefaultCookie() {
    authentication({
        result: true,
        data: {
            user: {
                id: "01",
                fullName: "User Test",
                role: {
                    code: "01",
                    name: "Admin 1"
                }
            },
            token: "assaaddffd",
            expiresOn: "",
            expiresDate: moment().add(50, "day")
        }
    })
}


// WEBPACK FOOTER //
// ./src/lib/auth.js